import Phaser from 'phaser';
import { BASE_H, BASE_W, COLORS } from '@/config/constants';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super('Preload');
  }

  preload(): void {
    const w = 480;
    const h = 24;
    const x = (BASE_W - w) / 2;
    const y = BASE_H / 2;

    const bg = this.add.graphics();
    bg.fillStyle(COLORS.panel, 1);
    bg.fillRoundedRect(x, y, w, h, 12);

    const bar = this.add.graphics();

    this.add
      .text(BASE_W / 2, y - 80, 'MATH NINJA', {
        fontFamily: 'Russo One, system-ui',
        fontSize: '72px',
        color: '#22d3ee'
      })
      .setOrigin(0.5);

    this.add
      .text(BASE_W / 2, y + 60, 'cargando...', {
        fontFamily: 'Inter, system-ui',
        fontSize: '24px',
        color: '#94a3b8'
      })
      .setOrigin(0.5);

    this.load.on('progress', (p: number) => {
      bar.clear();
      bar.fillStyle(COLORS.accent, 1);
      bar.fillRoundedRect(x, y, w * p, h, 12);
    });
  }

  create(): void {
    this.generateParticleTexture();
    this.scene.start('Game');
  }

  private generateParticleTexture(): void {
    if (this.textures.exists('particle')) return;
    const size = 24;
    const g = this.make.graphics({ x: 0, y: 0 }, false);
    g.fillStyle(0xffffff, 1);
    g.fillCircle(size / 2, size / 2, size / 2);
    g.generateTexture('particle', size, size);
    g.destroy();
  }
}
